module.exports = __webpack_public_path__ + "img/ic_male.307a972c.svg";